import { render, staticRenderFns } from "./userRole.vue?vue&type=template&id=9567c722&"
import script from "./userRole.vue?vue&type=script&lang=js&"
export * from "./userRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports